/**
 * Central localStorage / sessionStorage key names for the web app.
 * Use these instead of string literals so session-related touchpoints stay traceable.
 */
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'AUTH_TOKEN',
  REFRESH_TOKEN: 'REFRESH_TOKEN',
  TOKEN_EXPIRY: 'TOKEN_EXPIRY',
  USER_PROFILE: 'USER_PROFILE',
  SESSION_TOKEN: 'SESSION_TOKEN',
  PASSWORD_CHANGE_TOKEN: 'PASSWORD_CHANGE_TOKEN',
  I18N_LANG: 'i18nextLng',
} as const;

export type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];

/** Session keys (not localStorage) — keep names here for the same audit trail. */
export const SESSION_KEYS = {
  AUTH_LOGOUT_TOAST: 'AUTH_LOGOUT_TOAST',
} as const;
